import getConfig from 'next/config'
import { createThirdwebClient, type ThirdwebClient } from 'thirdweb'

import type { NextConfig } from 'next'

/**
 * Thirdweb Client.
 */
export default class Client {
  private static client: ThirdwebClient | null

  private constructor() {}

  static get instance() {
    // Return existing instance
    if (this.client != null) {
      return this.client
    }

    const { publicRuntimeConfig } = getConfig() as NextConfig

    if (typeof publicRuntimeConfig?.THIRDWEB_CLIENT_ID !== 'string') {
      throw new Error('Missing THIRDWEB_CLIENT_ID in publicRuntimeConfig')
    }

    // Create instance
    this.client = createThirdwebClient({
      clientId: publicRuntimeConfig.THIRDWEB_CLIENT_ID,
    })

    return this.client
  }
}
